import React, {Component} from 'react';
import CSSModules from 'react-css-modules'
import {Row, Col} from 'react-flexbox-grid'
import config from '../../config'
import container from '../../helpers/container'
import {
  ContainerDivs,
  Link,
  LinkIcon,
  SjfIssueCards,
  GetStartedInput
} from '../../components'
import Styles from './About.css'

@CSSModules(Styles, {allowMultiple:true})
export default class About extends Component {
  constructor(props) {
    super(props)
    this.state = { }
  }

  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
  }

  render() {
    const title = 'About Social Justice Funds'
    const url = config.domain + config.routes.about
    const aysLogo = require( '../../../static/images/AYS_R+large+RGB.jpg' )
    const chartsGraphic = require( '../../../static/images/about/charts-graphic.png' )
    const clipboardClockGraphic = require( '../../../static/images/about/clipboard-clock-graphic.png' )

    //
    return <div>
      {container.helmet(title, '', url)}
      <ContainerDivs>
        <div styleName='header'>
          <h1 styleName='header__headline'>{title}</h1>
        </div>
        <div styleName='header__copy'>
          <p>
            We believe that transparency and informed decision-making are the keys to fostering a more just and equitable society. Social Justice Funds is a search platform allows you to filter, search, and compare mutual funds based on how their underlying companies score on racial and social justice metrics. 
          </p>
          <p>
            You can harness your economic power to use your hard-earned savings to support the movement for true equity and the human dignity of all people. 
          </p>
        </div>

        <SjfIssueCards />

        <section styleName='section-panel'>
          <h2 styleName='section-panel__headline'>
            Who we are
          </h2>
          <div styleName='section-panel__content'>
            <div styleName='section-panel__copy-wrap'>
              <p styleName='section-panel__copy'>
                For over two decades, <Link xstrong title='As You Sow' to={config.links.ays}>As You Sow</Link> has promoted responsible investment. As part of our Invest Your Values program, we've created a series of tools that provide free information helping people invest fossil free, deforestation free, weapon free, and more. Invest Your Values interactive scorecards analyze the holdings of 6,000+ of the most held U.S. mutual funds and ETFs, the backbone of America’s 401(k)s, IRAs, and general investment portfolios. Each scorecard is updated monthly and screens funds’ current holdings, then analyzes and ranks performance on the specific environmental / social issue. Scorecards include an array of deep-dive information and an action toolkit.
              </p>
            </div>
            <div styleName='section-panel__image-wrap'>
              <img src={aysLogo} alt='As You Sow'  styleName='section-panel__logo-image'/>
            </div>
          </div>
        </section>


        <section styleName='section-panel'>
          <div styleName='section-panel__content'>
            <div styleName='section-panel__copy-wrap'>
              <h2 styleName='section-panel__headline'>
                How Social Justice Funds works
              </h2>
              <ul styleName='section-panel__list'>
                <li>
                  Look up mutual funds using up-to-date financial data 
                </li>
                <li>
                  We analyze your investments 
                </li>
                <li>
                  See how they’re rated on different social justice issues 
                </li>
              </ul>
              <div styleName='section-panel__link'>
                <Link roundbutton to={config.routes.methodology} title='How it works'>
                  How it works
                </Link>
              </div>
            </div>
            <div styleName='section-panel__image-wrap'>
              <img src={chartsGraphic} alt='How Social Justice Funds works'  styleName='section-panel__graphic-image'/>
            </div>
          </div>
        </section>


        <section styleName='section-panel'>
          <div styleName='section-panel__image-wrap'>
            <img src={clipboardClockGraphic} alt='Visit our Action Toolkit'  styleName='section-panel__graphic-image'/>
          </div>
          <h2 styleName='section-panel__headline section-panel__headline--center section-panel__headline--purple'>
            Visit our Action Toolkit
          </h2>
          <div styleName='section-panel__narrow-content'>
            <ul styleName='section-panel__list section-panel__list--flush'>
              <li>
                Learn how to make a change align your investments with Social Justice
              </li>
              <li>
                Ask your financial advisor about Social Justice investing
              </li>
              <li>
                Push your employer to provide socially just investment options
              </li>
            </ul>

            <Link roundbutton to={config.routes.toolkit} title='Take action'>
              Take action
            </Link>

          </div>

        </section>

      </ContainerDivs>

      { /* <GetStartedInput /> */ }
      
    </div>
  }
}
